import { render, staticRenderFns } from "./AddProgramModal.vue?vue&type=template&id=527a87f2&scoped=true"
import script from "./AddProgramModal.vue?vue&type=script&lang=js"
export * from "./AddProgramModal.vue?vue&type=script&lang=js"
import style0 from "./AddProgramModal.vue?vue&type=style&index=0&id=527a87f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527a87f2",
  null
  
)

export default component.exports